import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { QueIncluye } from './components/QueIncluye';
import { BeneficiosIdeal } from './components/BeneficiosIdeal';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { TestimoniosSection } from './components/TestimoniosSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="bg-[#0a1628] min-h-screen font-sans text-gray-100 selection:bg-[#fbbf24] selection:text-[#0a1628]" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Header data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <QueIncluye data-id="element-5" />
        <BeneficiosIdeal data-id="element-6" />
        <BonusSection data-id="element-7" />
        <PricingSection data-id="element-8" />
        <TestimoniosSection data-id="element-9" />
        <FinalCTA data-id="element-10" />
      </main>

      <Footer data-id="element-11" />
      <SocialProofPopup data-id="element-12" />
    </div>;
}